﻿import { exposeSearchUtilsToWindow } from "@js/core/utils/search";
import { exposeAcrMain } from "@js/components/common/acr-main";

export function initLegacyGlobals() {
    exposeSearchUtilsToWindow();
    exposeAcrMain();
}